import React from 'react';
import './about.scss';

const About = () => {
    return (
        <div className='about'>
            <p>Diseño web: <a href='https://twitter.com/Irisen_' target='blank'>Sandra Pinazo</a></p>
            <p>Idea: <a href='https://twitter.com/JacinMaeron' target='blank'>Jacinto García</a></p>
            <p>Arte: <a href='https://twitter.com/JacinMaeron' target='blank'>Jacinto García</a></p>
        </div>
    );
}

export default About;
